import React from "react";
import Typography from "aldoo-ra/Typography";
import CMSRender from "aldoo-ra/CMS/cms-render"

const AccountTypeCard = () => {
  return (
    <CMSRender
      contentType="AccountTypeCard"
      renderItem={(card) => {
        return (
      // Equal height is given to both the upper cards from the 1st row in Profile component for consistency.
      <div className="w-full h-[280px] flex flex-col items-start justify-between bg-paper rounded-[50px] px-[40px] py-[35px] shadow-card_shadow">
        {/* Row 1: Title and Account Type Label  */}
        <div className="w-full flex items-center justify-between">
          {/* Title */}
          <Typography 
            variant="h3" 
            className="text-text"
          >
            {card.title}
          </Typography>

          {/* Account Type Label */}
          {/* Please add logic for free / premium accounts */}
          <div className="h-[32px] flex items-center justify-center gap-1 bg-orange_lt rounded-full px-[10px] py-1 ml-auto">
            <img 
              src={card.premium_account_icon} 
              alt="Account type" 
              className="w-5 h-5" 
            />

            <Typography 
              variant="txt1_accent" 
              className="text-text"
            >
              {card.premium_account_text}
            </Typography>
          </div>
        </div>

        {/* Row 2: User Data  */}
        <div className="flex items-center justify-start gap-4">
          {/* Avatar */}
          <div className="w-[46px] h-[46px] flex items-center justify-center rounded-full overflow-hidden bg-gray_100">
            {/* Default Avatar */}
            <img 
              src={card.avatar} 
              alt="Avatar" 
              className="w-8 h-8" 
            />
          </div>

          {/* User Info */}
          <div className="flex flex-col items-start justify-center">
            <Typography variant="body1_accent" className="my-0">
              {card.username}
            </Typography>

            <Typography variant="txt1_dim">
              {card.email}
            </Typography>
          </div>
        </div>

        {/* Row 3: Subscription Type + Renewal Date */}
        <div className="w-full flex items-center justify-between gap-4">
          {/* Subscription Type */}
          <Typography 
            variant="body1" 
            className="font-medium text-text my-0"
          >
            {card.subscription_type}
          </Typography>

          {/* Renewal Date */}
          <div className="flex items-center gap-[7px] ml-auto">
            {/* Renewal Icon */}
            <img 
              src={card.renewal_icon} 
              alt="Account type" 
              className="w-4 h-4" 
            />

            <Typography variant="txt1_dim">
              {card.renewal_info}
            </Typography>
          </div>
        </div>

      </div>
        )
      }}
    />
  );
};

export default AccountTypeCard;
